import axios from "axios";

export default function uploadLeaseTemplate({ formData, jwt }) {
  return new Promise((resolve, reject) => {
    const backend_url = process.env.REACT_APP_BACKEND_URL;
    axios({
      url: `${backend_url}/lease-templates`,
      method: "POST",
      data: formData,
      headers: {
        Authorization: `Bearer ${jwt}`,
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) =>
        resolve({
          data: res.data,
          error: false,
          complete: true,
        })
      )
      .catch((e) => {
        reject({
          data: null,
          error: true,
          errorMessage: e.response ? e.response.data : e,
          complete: true,
        });
      });
  });
}
